import { Expose } from 'class-transformer';
import StockCentralItem from './stock-central.model';

export default class StockCentralResponse {
  @Expose()
  stocks!: StockCentralItem[];

  @Expose()
  total!: number;

  constructor() {
    this.stocks = [];
    this.total = 0;
  }
}
